import Accounts from "../../pages/Accounts";
import {connect} from "react-redux";

const mapStateToProps = (state, ownProps) => {
    const { user, isAuthenticated } = state;
    const { cookies } = ownProps;
    return { user, cookies, isAuthenticated }
};

const AccountsAdapter = connect(mapStateToProps)(Accounts);
export default AccountsAdapter;